import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getCustomerZoneModelChange } from "../actions/dashboardActions";
import { utils } from "../common/utils";
import { Breakpoint } from 'react-socks';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCalendarTimes,faCalendarCheck,faShieldAlt,faChevronDown,faHome,} from "@fortawesome/free-solid-svg-icons";

export default function Timeline() {

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { items, loading } = useSelector( (state) => state.dashboard.customerZoneModelChange || { items: [], loading: false } );

  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (user && user.id) {
      dispatch(getCustomerZoneModelChange(user.id));
    }
  }, [dispatch, user]);

  console.log('items',items);
  const data = items.map((item) => ({
    id: item.id,
    year: new Date(item.changeDate).getFullYear(),
    date: new Date(item.changeDate).toLocaleDateString("en-US", {year: "numeric", month: "short",day: "numeric",}),
    //date: item.changeDate ? utils.dates.getDateString(item.changeDate) : "-",
    zoneName: item.zoneModel.name,
    statusText: utils.customers.getZoneChangeReasonString(item.status) ?? "Unknown",
    previousStatusText: utils.customers.getZoneChangeReasonString(item.previousStatus) ?? "Unknown",
    //oldExpiry: item.oldExpiryDate ? new Date(item.oldExpiryDate).toLocaleDateString("en-US") : null,
    //newExpiry: item.newExpiryDate ? new Date(item.newExpiryDate).toLocaleDateString("en-US") : null,
    oldExpiry: item.previousStatus <= 3 && item.oldExpiryDate ? utils.dates.getDateString(item.oldExpiryDate) : "-",
    newExpiry: item.status != 3 && item.newExpiryDate ? utils.dates.getDateString(item.newExpiryDate) : "-",
    points: item.points,
  }));

  return (
    <div style={{ position: "relative", padding: "40px 0px" }}>
       {data.length > 0 && (
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: 0,
            bottom: 0,
            width: "2px",
            background: "#ccc",
            transform: "translateX(-50%)",
            zIndex: 0,
          }}
        />
      )}
       {data.length === 0 ? (<p style={{ textAlign: "center", color: "#555" }}> {t("There are no records to display")} </p>) : (
        data.map((ev, index) => <TimelineEvent key={ev.id} ev={ev} index={index} />)
      )}
    </div>
  );
}

function TimelineEvent({ ev, index }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = React.useState(true);
  const isLeft = index % 2 === 0;

  // date style placed on opposite side of the card
  const dateStyle = {
    position: "absolute",
    top: "20px",
    color: "#555",
    fontSize: "14px",
    zIndex: 2,
    ...(isLeft
      ? { left: "calc(50% + 18px)", textAlign: "left" }
      : { right: "calc(50% + 18px)", textAlign: "right" }),
  };

  return (
    <div
      style={{
        position: "relative",
        margin: "60px 0",
        display: "flex",
        justifyContent: isLeft ? "flex-start" : "flex-end",
      }}
    >
      {/* Year badge */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "-25px",
          transform: "translateX(-50%)",
          background: "#0078c8",
          color: "#fff",
          padding: "3px 10px",
          borderRadius: "4px",
          fontWeight: "bold",
          zIndex: 2,
        }}
      >
        {ev.year}
      </div>

      {/* Dot (center of line) */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "20px",
          transform: "translateX(-50%)",
          display: "flex",
          alignItems: "center",
          zIndex: 2,
        }}
      >
        <span
          style={{
            width: "14px",
            height: "14px",
            background: "#0078c8",
            borderRadius: "50%",
            border: "2px solid #fff",
            display: "inline-block",
          }}
        />
      </div>

      <div style={dateStyle}>{ev.date}</div>

      {/* Card */}
      <div
        style={{
          position: "relative",
          width: "45%",
          background: "#fff",
          borderRadius: "8px",
          padding: 0,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          overflow: "hidden",
          zIndex: 1,
        }}
      >
        <div
          style={{
            padding: "12px 16px",
            background: "#f9f9f9",
            borderBottom: "1px solid #eee",
            cursor: "pointer",
          }}
          onClick={() => setExpanded(!expanded)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
             <Breakpoint medium up>
                <h6 style={{ margin: "6px 0 0 34px",fontSize: 14,fontWeight: 500, color: "#444", }}>
                {ev.statusText}
                </h6>
            </Breakpoint>
            <Breakpoint small down>
                <h6 style={{ margin: "6px 0 0 0px",fontSize: 12,fontWeight: 500, color: "#444", }}>
                    {ev.statusText}
                </h6>
            </Breakpoint>

            <FontAwesomeIcon
              icon={faChevronDown}
              style={{
                color: "#555",
                transform: expanded ? "rotate(0deg)" : "rotate(-90deg)",
                transition: "transform 0.15s ease",
              }}
            />
          </div>
        </div>

        {expanded && (
  <div
    style={{
      padding: "16px",
      display: "flex",
      flexWrap: "wrap",       
      justifyContent: "space-around",
      alignItems: "center",
      gap: "20px",
      textAlign: "center",
      }}
  >
    <div style={{ flex: 1 }}>
      <FontAwesomeIcon icon={faCalendarTimes} color="#e11d48" size="lg" />
      <h6 style={{ color: "#e11d48", margin: "6px 0", fontSize: 13 }}>
        {ev.oldExpiry}
      </h6>
      <p style={{ fontSize: 11, textTransform: "uppercase", color: "#555" }}>
        {t("OldExpiryDate")}
      </p>
    </div>

    <div style={{ flex: 1 }}>
      <FontAwesomeIcon icon={faCalendarCheck} color="#f59e0b" size="lg" />
      <h6 style={{ color: "#f59e0b", margin: "6px 0", fontSize: 13 }}>
        {ev.newExpiry}
      </h6>
      <p style={{ fontSize: 11, textTransform: "uppercase", color: "#555" }}>
        {t("NewExpiryDate")}
      </p>
    </div>
  </div>
)}
      </div>
    </div>
  );
}
